import { Component, OnInit, Input  } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { RelationshipService } from '../../shared/services/relationship.service';
import {   IRelationshipMain, IRelationshipCodeLineItems } from '../../shared/models/relationship';
import { Router } from '@angular/router';
import { Config } from 'src/app/shared/config';
import { IApplicationRoles } from 'src/app/shared/models/common';
@Component({
  selector: 'app-relationshipgrid',
  templateUrl: './relationshipgrid.component.html',
  styleUrls: ['./relationshipgrid.component.css'],
  providers: [RelationshipService]
})
export class RelationshipgridComponent implements OnInit {
  @Input() public codeID: number;
  view: boolean; loading: boolean;
  @Input() public mappingDetailsGrid: IRelationshipCodeLineItems[];
  roleID: number;
  itroleID: number;
  constructor(private frmbuilder: FormBuilder,
    private dataService: RelationshipService, private route: Router) { }

  ngOnInit() {
    this.getMappingdeatils(this.codeID);
    this.view = false;
    this.loading = false;
    this.roleID = Config.userProfile.itApplicationRoleID;
    this.itroleID = IApplicationRoles.Administrator;
  }
  getMappingdeatils(codeid: number) {
      this.loading = true;
    this.mappingDetailsGrid = this.mappingDetailsGrid.filter(C => C.mCodeID === codeid);
    this.loading = false;
  }

}


